import { ShieldAlert } from 'lucide-react';
import { isMalwareBlocked, MALWARE_BLOCKED_MESSAGE } from '../malware';

/** Short label shown next to a blocked file's name. */
export default function MalwareBadge({ file }) {
  if (!isMalwareBlocked(file)) return null;
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 text-xs font-medium text-red-700"
      title={MALWARE_BLOCKED_MESSAGE}
    >
      <ShieldAlert className="h-3.5 w-3.5" aria-hidden="true" />
      Blocked: malware
    </span>
  );
}
